export interface EnvDef {
  production: boolean;
  releaseVersion: string;
  storagePrefix: string;
  apiUrl: string;
  proxyApiUrl: string;
  zohoBooksOrganizationId: string;
  appscriptsUrl: string;
  statusPageId: string;
  networksOnlineUrl: string;
  networkUpdatesUrl: string;
  networksOnlineRcsUrl: string;
  networkUpdatesRcsUrl: string;
  networksOnlineFlashCallUrl: string;
  networkUpdatesFlashCallUrl: string;
  moNetworksOnlineUrl: string;
  moNetworkUpdatesUrl: string;
  voiceNetworksOnlineUrl: string;
  voiceNetworkUpdatesUrl: string;
  forcedUpdate: boolean;
  postponeUpdates: string[];
  ignoreUpdateUserIds: Set<number>;
  agGridLicenseKey: string;
  recaptchaSiteKey: string;
  recaptchaBaseUrl: string;
  countriesApiUrl: string;
  backendChannelResetTag: number;
  showInvoiceDeleteToUserIds: Set<number>;
  cloudwatchDeviceLogsUrl: string;
  clicktermAppId: string;
  clicktermTemplateId: string;
  clicktermMsaDpaTemplateId: string;
  clicktermPromoBannerEnabled: boolean;
  duckpostOrganizationId: string;
  duckpostOrganizationSlug: string;
}

export const defaults = {
  storagePrefix: 'telq_',
  releaseVersion: 'default',
  apiUrl: 'http://localhost:8080',
  proxyApiUrl: 'http://localhost:8080',
  zohoBooksOrganizationId: '776762815',
  appscriptsUrl: 'https://appscripts.telqtele.com/v2.2',
  statusPageId: '8mnnnzvs0gsr',
  networksOnlineUrl: 'https://sse.dev.telqtele.com/networks/online',
  networkUpdatesUrl: 'https://sse.dev.telqtele.com/networks/updates',
  networksOnlineRcsUrl: 'https://sse.dev.telqtele.com//networks/rcs-online',
  networkUpdatesRcsUrl: 'https://sse.dev.telqtele.com/networks/rcs-updates',
  networksOnlineFlashCallUrl: 'https://sse.dev.telqtele.com/networks/flash-call-online',
  networkUpdatesFlashCallUrl: 'https://sse.dev.telqtele.com/networks/flash-call-updates',
  moNetworksOnlineUrl: 'https://sse.dev.telqtele.com/networks/mo-online',
  moNetworkUpdatesUrl: 'https://sse.dev.telqtele.com/networks/mo-updates',
  voiceNetworksOnlineUrl: 'https://sse.dev.telqtele.com/networks/voice-online',
  voiceNetworkUpdatesUrl: 'https://sse.dev.telqtele.com/networks/voice-updates',
  forcedUpdate: false,
  postponeUpdates: ['/live-testing', '/manual-testing', '/scheduler/tasks/create', '/cli-testing', '/mo-testing'],
  recaptchaSiteKey: '6LcTiYMlAAAAAO6gzYFOXtRPErMzf0SqKOMTiFB4',
  recaptchaBaseUrl: 'https://www.recaptcha.net/recaptcha/api.js',
  countriesApiUrl: 'https://api.dev.moneysmsapp.com/v2.4/platform/countries',
  backendChannelResetTag: 1,
  ignoreUpdateUserIds: new Set([
    2752, 2694, 2672, 2671, 2670, 2554, 2553, 2552, 2551, 2971, 2979, 2980, 2989, 2990, 2991, 2992, 3001, 3002, 3003, 3004, 3005, 3006,
  ]),
  showInvoiceDeleteToUserIds: new Set([852, 849]),
  cloudwatchDeviceLogsUrl:
    'http://grafana.telqtele.internal/d/b2f9b024-fc5f-4edd-8701-a623d6a578b1/device-log?orgId=1&from=now-3h&to=now&var-environment=dev&var-phoneNumber={PHONENUMBER}',
  clicktermAppId: '01K3JTVKSWJX6CXKN95RDKKDJ0',
  clicktermTemplateId: '79c1b858-400e-4d04-af14-29807d43b34a',
  clicktermMsaDpaTemplateId: '12192110-50b1-4368-99dc-4a9d9edc4f05',
  clicktermPromoBannerEnabled: true,
  duckpostOrganizationId: '5b95ca2b-be33-4e41-a861-ae09a16b87ce',
  duckpostOrganizationSlug: 'telq-telecom-2',
};
